<template lang="pug">
    LoginJF(v-if="isJF")
    login(v-else)
</template>

<script>
import Login from '@/components/login/App.vue'
import LoginJF from '@/components/login/jfApp.vue'

export default {
  name: 'App',
  components: { Login, LoginJF },
  data() {
    return {
      isJF: false
    }
  },
  beforeCreate() {
    document.title = window.ConfigNew.header.title
  },
  created() {
    this.isJF = window.navigator.userAgent.match(/Electron/)
  }
}
</script>
<style lang="css">
@import url('../src/ui/css/ui.css');
</style>



// WEBPACK FOOTER //
// src/App.vue